import { render, staticRenderFns } from "./goodsInventoryQuotation.vue?vue&type=template&id=516fb94c&scoped=true"
import script from "./goodsInventoryQuotation.vue?vue&type=script&lang=js"
export * from "./goodsInventoryQuotation.vue?vue&type=script&lang=js"
import style0 from "./goodsInventoryQuotation.vue?vue&type=style&index=0&id=516fb94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516fb94c",
  null
  
)

export default component.exports